export default __webpack_public_path__ + "static/media/img-0135-germany-full-face.c87dfb0e.png";